<template>
  <div>
    <div class="d-flex-responsive">
      <div class="card card__gutter card__gutter__left d-flex justify-content-center w-50-responsive">
        <p>
          {{ $t('messages.store_other_items') }}
        </p>
        <p>
          <b-link to="/contact" class="font-weight-bold no-decoration">
            {{ $t('messages.store_other_items_contact') }}
          </b-link>
        </p>
      </div>
      <div class="card card__gutter card__gutter__right text-right-responsive w-50-responsive">
        <p><span class="font-weight-bold">{{ $t('messages.shipping_info_free_pickup_pre') }}</span> {{ $t('messages.shipping_info_free_pickup_post') }}</p>
        <p><span class="font-weight-bold">{{ $t('messages.shipping_info_free_pre') }}</span> {{ $t('messages.shipping_info_free_post') }}</p>
        <p><span class="font-weight-bold">{{ $t('messages.shipping_info_free_abroad_pre') }}</span> {{ $t('messages.shipping_info_free_abroad_post') }}</p>
        <b-link to="/shipping" class="font-weight-bold no-decoration">
          {{ $t('messages.shipping_info_link') }}
        </b-link>
      </div>
    </div>
    <div class="d-flex-responsive">
      <div class="filter-wrapper">
        <div class="card non-mobile-show">
          <h1 class="card__title">
            {{ $t('messages.filter') }}
          </h1>
          <div class="card__description">
            <product-filter v-model="params" :publishers="publishers"></product-filter>
          </div>
          <div class="clear"></div>
        </div>
        <div class="mobile-show mb-4">
          <b-button class="w-100" variant="primary" v-b-modal.filter-modal>{{ $t('messages.filter') }}</b-button>
        </div>
      </div>
      <div class="w-100">
        <div class="d-flex sort-select">
          <span class="font-weight-bold mr-2">{{ $t('messages.sort') }}:</span>
          <b-form-select v-model="params.sort">
            <option value="nameAsc">{{ $t('messages.sort_name_asc') }}</option>
            <option value="nameDesc">{{ $t('messages.sort_name_desc') }}</option>
            <option value="priceAsc">{{ $t('messages.sort_price_asc') }}</option>
            <option value="priceDesc">{{ $t('messages.sort_price_desc') }}</option>
            <option value="timeAsc">{{ $t('messages.sort_time_asc') }}</option>
            <option value="timeDesc">{{ $t('messages.sort_time_desc') }}</option>
          </b-form-select>
        </div>
        <masonry :cols="{ default: 5, 1600: 4, 1300: 3, 1000: 2, 700: 1 }" :gutter="{ default: '15px' }"
          class="masonry">
          <product-tile v-if="products.length > 0" v-for="product in products" :product="product" :key="product.id"></product-tile>
        </masonry>
        <div class="alert alert-danger products-div" v-if="products.length === 0 && initialized">
          {{ $t('messages.products_empty_all') }}
        </div>
        <div class="load-more-wrapper">
          <b-button v-if="hasMore" variant="primary" class="w-100" @click="loadMore">
            {{ $t('messages.load_more') }}
          </b-button>
        </div>
      </div>
    </div>

    <b-modal id="filter-modal" :title="$t('messages.filter')" hide-footer>
      <product-filter v-model="params" :publishers="publishers"></product-filter>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import VueMasonry from 'vue-masonry-css'
import ProductTile from '../../components/product/ProductTile'
import ProductFilter from '../../components/product/ProductFilter'

import { defaultMixin } from '../../mixin/default'
import { navigationMixin } from '../../mixin/navigation'

import { productService } from '../../services/product.service'

Vue.use(VueMasonry)

export default {
  name: 'productdashboard',
  mixins: [ defaultMixin, navigationMixin ],
  components: { ProductTile, ProductFilter },
  data: function () {
    return {
      params: {
        page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
        minPrice: this.$route.query.minPrice ? parseInt(this.$route.query.minPrice) : null,
        maxPrice: this.$route.query.maxPrice ? parseInt(this.$route.query.maxPrice) : null,
        availability: this.$route.query.availability ? [ this.$route.query.availability ] : [],
        publishers: this.$route.query.publishers ? this.$route.query.publishers.split(',') : [],
        languages: this.$route.query.languages ? this.$route.query.languages.split(',') : [],
        category: this.$route.query.category ? parseInt(this.$route.query.category) : null,
        sort: this.$route.query.sort ? this.$route.query.sort : 'timeDesc',
        sale: this.$route.query.sale ? this.$route.query.sale : false,
        damaged: this.$route.query.damaged ? this.$route.query.damaged : false
      },
      initialized: false,
      size: 20,
      hasMore: false,
      products: [],
      publishers: []
    }
  },
  methods: {
    fetchProducts: function () {
      let loader = this.$loading.show()
      let store = this.$store
      let filter = {
        page: this.initialized ? this.params.page : 1,
        size: this.initialized ? this.size : (this.params.page * this.size),
        search: store.state.search,
        minPrice: this.params.minPrice,
        maxPrice: this.params.maxPrice,
        availability: (this.params.availability.length > 0) ? this.params.availability[0] : null,
        publishers: this.params.publishers,
        languages: this.params.languages,
        category: this.params.category,
        sort: this.params.sort,
        sale: this.params.sale,
        damaged: this.params.damaged
      }

      productService.fetch(filter)
        .then((products) => {
          if (this.params.page === 1) {
            this.products = products
          } else {
            this.products = this.products.concat(products)
          }
          this.hasMore = products.length === (this.initialized ? this.size : (this.params.page * this.size))
          loader.hide()
          if (!this.initialized) {
            this.$store.commit('moveToScrollPosition')
          }
          this.initialized = true
        }, () => {
          store.commit('error', 'errors.products')
          loader.hide()
          this.initialized = true
        })
    },
    loadMore: function () {
      this.params.page += 1
      this.load()
    },
    resetAndLoad: function () {
      this.params.page = 1
      this.load()
    },
    load: function () {
      let params = this.params
      let query = this.generateQueryParams(params)
      this.pushUrlState(query)
      this.fetchProducts()
    }
  },
  created: function () {
    this.fetchProducts()
    productService.fetchPublishers()
      .then((publishers) => {
        this.publishers = publishers
      }, () => {
        this.$store.commit('error', 'errors.publisher')
      })
    this.$root.$on('searchProducts', () => {
      this.hasMore = false
      this.params.page = 1
      this.products = []
      this.fetchProducts()
    })
  },
  watch: {
    'params.availability': function () {
      if (this.params.availability.length > 1) {
        this.params.availability = [this.params.availability[this.params.availability.length - 1]]
      }
      this.resetAndLoad()
    },
    'params.publishers': function () {
      this.resetAndLoad()
    },
    'params.languages': function () {
      this.resetAndLoad()
    },
    'params.minPrice': function () {
      this.resetAndLoad()
    },
    'params.maxPrice': function () {
      this.resetAndLoad()
    },
    'params.sort': function () {
      this.resetAndLoad()
    }
  },
  beforeDestroy: function () {
    this.$root.$off('searchProducts')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .card__gutter__left {
    margin-right: 10px !important;
  }

  .card__gutter__right {
    margin-left: 10px !important;
  }

  .filter-wrapper {
    padding: 5px 10px 0px;
    margin-bottom: -15px;
  }

  .sort-select {
    width: 300px;
    margin: 10px 10px 0px;
    line-height: 35px;
  }

  .masonry {
    padding: 10px;
  }

  .load-more-wrapper {
    margin-top: -20px;
    padding: 0px 10px 10px;
  }

  .no-decoration {
    text-decoration: none;
  }

  .products-div {
    margin: -10px 10px 20px;
  }

  @media screen and (min-width: 901px) {
    .filter-wrapper {
      min-width: 350px;
      padding: 10px 5px 10px 10px;
    }

    .w-50-responsive {
      width: 50%;
    }

    .text-right-responsive {
      text-align: right;
    }
  }

  .mobile-show {
    display: flex;
  }

  .non-mobile-show {
    display: none;
  }

  @media screen and (min-width: 768px) {
    .mobile-show {
      display: none;
    }

    .non-mobile-show {
      display: flex;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/ProductDashboard.vue